export default {"src":"/_next/static/media/BicycleIconCompare.999aba77.svg","height":43,"width":62,"blurWidth":0,"blurHeight":0};